import { createContext, PropsWithChildren, useContext } from 'react';

export type FollowingViewContextType = {
  operationId: string;
  walletId: number | null;
  operationName: string;
  indicatorsCompetencyDate: string;
  handleIndicatorsCompetencyDateChange: (
    e: React.MouseEvent<HTMLButtonElement>,
    direction: 'previous' | 'next',
  ) => void;
  /** Abre o modal com as versões completas dos três gráficos. */
  onCompleteView: () => void;
  childOperationIds?: string[];
};

const FollowingViewContext = createContext<FollowingViewContextType | null>(
  null,
);

export function useFollowingViewContext() {
  const context = useContext(FollowingViewContext);

  if (!context) {
    throw new Error(
      'useFollowingViewContext must be used within an FollowingViewProvider',
    );
  }

  return context;
}

type FollowingViewProviderProps = PropsWithChildren<FollowingViewContextType>;

export function FollowingViewProvider({
  children,
  ...value
}: FollowingViewProviderProps) {
  return (
    <FollowingViewContext.Provider value={value}>
      {children}
    </FollowingViewContext.Provider>
  );
}
